import {ReactNode} from "react";
import {css} from "@panda/css";

import {BrandLightBulbIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {InsightVariant} from "./InsightVariant";

interface IProps {
    variant: InsightVariant;
    isLoading: boolean;
    percentageBelow: number | null;
    promotionExample: string | null;
}

export const PropertyInsightBox = (props: IProps) => {
    const {variant, isLoading, percentageBelow, promotionExample} = props;

    if (variant === InsightVariant.NONE) {
        return null;
    }

    const variantMessage: Omit<Record<InsightVariant, ReactNode>, InsightVariant.NONE> = {
        [InsightVariant.PRICE_ABOVE_AVERAGE]: (
            <>
                <Text variant="body_copy_2" as="span">
                    Cena tego mieszkania jest nieco wyższa niż rynkowa średnia w tej okolicy.
                </Text>{" "}
                <Text variant="info_txt_1" as="span">
                    <strong>Warto zapytać dewelopera o możliwość negocjacji i obniżenia ceny.</strong>
                </Text>
            </>
        ),
        [InsightVariant.HAS_OFFER_PROMOTIONS]: (
            <>
                <Text variant="body_copy_2" as="span">
                    Wiemy, że ten deweloper oferuje teraz promocje na wybrane lokale.
                </Text>{" "}
                <Text variant="info_txt_1" as="span">
                    <strong>Warto sprawdzić, czy obejmują one również to mieszkanie.</strong>
                </Text>
            </>
        ),
        [InsightVariant.HAS_PROPERTY_PROMOTION]: (
            <>
                <Text variant="body_copy_2" as="span">
                    Ta oferta jest objęta specjalną promocją{!!promotionExample ? ` ${promotionExample}` : ""}.
                </Text>{" "}
                <Text variant="info_txt_1" as="span">
                    <strong>Skontaktuj się z deweloperem i poznaj szczegóły, zanim akcja się zakończy.</strong>
                </Text>
            </>
        ),
        [InsightVariant.PRICE_OPTIMAL]: (
            <>
                <Text variant="body_copy_2" as="span">
                    Z naszych danych wynika, że cena tego mieszkania idealnie wpisuje się w średnią dla tej okolicy.
                </Text>{" "}
                <Text variant="info_txt_1" as="span">
                    <strong>Pamiętaj jednak, że zawsze możesz zapytać w biurze sprzedaży o dodatkowy rabat.</strong>
                </Text>
            </>
        ),
        [InsightVariant.PRICE_BELOW_AVERAGE]: (
            <>
                <Text variant="body_copy_2" as="span">
                    Świetna okazja! Cena tego mieszkania jest o {percentageBelow}% niższa niż rynkowa średnia w tej okolicy.
                </Text>{" "}
                <Text variant="info_txt_1" as="span">
                    <strong>Warto zapytać dewelopera o szczegóły, zanim oferta zniknie</strong>
                </Text>
            </>
        )
    };

    if (isLoading) {
        return (
            <div className={loaderWrapperStyle}>
                <Loader />
            </div>
        );
    }

    return (
        <div className={insightBoxStyle}>
            <BrandLightBulbIcon size="2.5" wrapperSize="2.5" wrapperColor="transparent" />
            <div>{variantMessage[variant]}</div>
        </div>
    );
};

const loaderWrapperStyle = css({
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    p: 2
});

const insightBoxStyle = css({
    alignItems: "center",
    background: "var(--colors-background-100)",
    border: "1px solid var(--colors-gray-300)",
    borderRadius: 0.5,
    display: "flex",
    gap: 2,
    p: 1
});
import {ReactNode} from "react";
import {css} from "@panda/css";

import {BrandLightBulbIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {InsightVariant} from "./InsightVariant";

interface IProps {
    variant: InsightVariant;
    isLoading: boolean;
    percentageBelow: number | null;
    promotionExample: string | null;
}

export const PropertyInsightBox = (props: IProps) => {
    const {variant, isLoading, percentageBelow, promotionExample} = props;

    if (variant === InsightVariant.NONE) {
        return null;
    }

    const variantMessage: Omit<Record<InsightVariant, ReactNode>, InsightVariant.NONE> = {
        [InsightVariant.PRICE_ABOVE_AVERAGE]: (
            <>
                <Text variant="body_copy_2" as="span">
                    Cena tego mieszkania jest nieco wyższa niż rynkowa średnia w tej okolicy.
                </Text>{" "}
                <Text variant="info_txt_1" as="span">
                    <strong>Warto zapytać dewelopera o możliwość negocjacji i obniżenia ceny.</strong>
                </Text>
            </>
        ),
        [InsightVariant.HAS_OFFER_PROMOTIONS]: (
            <>
                <Text variant="body_copy_2" as="span">
                    Wiemy, że ten deweloper oferuje teraz promocje na wybrane lokale.
                </Text>{" "}
                <Text variant="info_txt_1" as="span">
                    <strong>Warto sprawdzić, czy obejmują one również to mieszkanie.</strong>
                </Text>
            </>
        ),
        [InsightVariant.HAS_PROPERTY_PROMOTION]: (
            <>
                <Text variant="body_copy_2" as="span">
                    Ta oferta jest objęta specjalną promocją{!!promotionExample ? ` ${promotionExample}` : ""}.
                </Text>{" "}
                <Text variant="info_txt_1" as="span">
                    <strong>Skontaktuj się z deweloperem i poznaj szczegóły, zanim akcja się zakończy.</strong>
                </Text>
            </>
        ),
        [InsightVariant.PRICE_OPTIMAL]: (
            <>
                <Text variant="body_copy_2" as="span">
                    Z naszych danych wynika, że cena tego mieszkania idealnie wpisuje się w średnią dla tej okolicy.
                </Text>{" "}
                <Text variant="info_txt_1" as="span">
                    <strong>Pamiętaj jednak, że zawsze możesz zapytać w biurze sprzedaży o dodatkowy rabat.</strong>
                </Text>
            </>
        ),
        [InsightVariant.PRICE_BELOW_AVERAGE]: (
            <>
                <Text variant="body_copy_2" as="span">
                    Świetna okazja! Cena tego mieszkania jest o {percentageBelow}% niższa niż rynkowa średnia w tej okolicy.
                </Text>{" "}
                <Text variant="info_txt_1" as="span">
                    <strong>Warto zapytać dewelopera o szczegóły, zanim oferta zniknie</strong>
                </Text>
            </>
        )
    };

    if (isLoading) {
        return (
            <div className={loaderWrapperStyle}>
                <Loader />
            </div>
        );
    }

    return (
        <div className={insightBoxStyle}>
            <BrandLightBulbIcon size="2.5" wrapperSize="2.5" wrapperColor="transparent" />
            <div>{variantMessage[variant]}</div>
        </div>
    );
};

const loaderWrapperStyle = css({
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    p: 2
});

const insightBoxStyle = css({
    alignItems: "center",
    background: "var(--colors-background-100)",
    border: "1px solid var(--colors-gray-300)",
    borderRadius: 0.5,
    display: "flex",
    gap: 2,
    p: 1
});
